export const SocketEventType = {
  NEW_NOTIFICATION: 'NEW_NOTIFICATION',
};

export const socketEventTypes = [
  SocketEventType.NEW_NOTIFICATION,
];